import type { LayoutConfig } from "../../hooks/useLayoutConfig";

export const accountLayoutConfig: LayoutConfig = {
  topBar: {
    hideRoutes: ["/invite/*"],
  },
  sidebar: {
    hideRoutes: ["/accounts", "/invite/*"],
    mobileHideRoutes: [],
  },
  overlays: {
    hideRoutes: ["/invite/*"],
  },
  skeleton: {
    hideRoutes: ["/invite/*"],
  },
};
